import {
  StatusCodes,
  getReasonPhrase
} from 'http-status-codes';
import _ from 'lodash';

function getApiBaseUrl() {
  return API_BASE_URL || _.get(window.location, 'origin', window.location.host).replace('app', 'api');
}

export default function fetchApiConfig() {
  // Defaults for environment configuration
  const env = {
    apiBaseUrl: getApiBaseUrl(),
    appVersion: APP_VERSION,
    eventsConfig: {
      eventPanelExclusions: []
    },
    user: {
      kind: 'anonymous'
    }
  };
  _.assign(env, window.__env);

  // This technique is used so that configuration can be retrieved asynchronously
  // basically, it gets an instance of $http before angular is actually loaded.
  // After getting the global config options, we load the app
  const initInjector = angular.injector(['ng']);

  const $http = initInjector.get('$http');
  // Super important! if withCredentials not set, the request does not send cookies, then
  // /admin/config comes always as anonymous
  $http.defaults.withCredentials = true;

  const $log = initInjector.get('$log');
  const $window = initInjector.get('$window');

  $log.debug('Getting WebApp configuration');

  return $http.get(`${env.apiBaseUrl}/admin/config`, { timeout: 10000 })
    .then((response) => {
      if (_.get(response, 'httpStatus') === StatusCodes.TEMPORARY_REDIRECT ||
        _.get(response, 'data.user.kind') === 'anonymous') {

        const fullAppUrl = $window.location.href;
        const loginUrl = `${env.apiBaseUrl}/account/login/`;
        const redirectUrl = _.get(response, 'data.extraErrorInfo.redirectUrl',
          _.get(response, 'extraErrorInfo.redirectUrl', loginUrl));
        $window.location = `${redirectUrl}?redirectUrl=${encodeURIComponent(fullAppUrl)}`;
      }

      const { data: appConfig } = response;
      const DEFAULT_USER_SETTINGS = {
        groupedBoardsView: false
      };
      _.defaults(appConfig.user.settings, DEFAULT_USER_SETTINGS);
      return _.merge(env, appConfig);
    })
    .catch((res) => {

      // See more: /api/policies/
      const httpStatus = _.get(res, 'status') || _.get(res, 'httpStatus');
      const authInvalid = [StatusCodes.TEMPORARY_REDIRECT, StatusCodes.PAYMENT_REQUIRED].includes(httpStatus);
      const maintenanceMode = httpStatus === StatusCodes.SERVICE_UNAVAILABLE;
      const timedOut = httpStatus === -1;
      const userIsHuman = !(/headless/i).test(window.navigator.userAgent); // needed during tests

      console.debug(`
        Issue(s) encountered while fetching API config 🙈
        API config response details:
          Request: ${(timedOut && '❌ Aborted') || `❌ ${httpStatus} - ${getReasonPhrase(httpStatus)}`}
          Authentication: ${authInvalid ? '❌ Invalid' : '✅ Valid'}
          ${maintenanceMode ? '⚠️ Maintenance Mode Active' : ''}
          User is: ${userIsHuman ? '✅ Human' : '🤖 Robot'}
          Raw:
      `, _.get(res, 'err', res));

      // Check your human privilege
      if (!userIsHuman) {
        return;
      }

      if (authInvalid) {
        console.debug('Redirecting to login page');
        const redirectUrl =
          _.get(res, 'data.extraErrorInfo.redirectUrl') ||
          _.get(res, 'extraErrorInfo.redirectUrl', `${env.apiBaseUrl}/account/login/`);
        window.location = `${redirectUrl}?redirectUrl=${encodeURIComponent($window.location.href)}`;
      } else {
        console.debug('Redirecting to maintenance page');
        window.location = '/maint.html';
      }

    });
}
